import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class DepotTable extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }

  render() {
    const { depots } = this.props;
    return (
      <Table responsive striped>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Customer</th>
            <th>Time Zone</th>
            <th>MapOverlay</th>
            <th>Updated</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {depots.map((depot, index) => {
            return (
              <tr key={index}>
                <td>{depot.name}</td>
                <td>{depot.description}</td>

                <a
                  onClick={() =>
                    localStorage.setItem(
                      "customer",
                      JSON.stringify({
                        customerId: depot.customerId,
                        customerName: depot.customerName,
                      })
                    )
                  }
                  href={`/depots?customerId=${depot.customerId}&customerName=${depot.customerName}`}
                >
                  <td>{depot.customerName}</td>
                </a>

                <td>{depot.timeZoneCity}</td>
                <td className="width-adjust">{depot.mapOverlay}</td>
                <td>{utcToLocal(depot.dbUpdated)}</td>

                <td>
                  <Link to={`/editDepot/${depot.id}`}>Edit</Link> |{" "}
                  <Link to={`/depotDetails/${depot.id}`}>Details</Link> |{" "}
                  <Link to={`/deleteDepot/${depot.id}`}>Delete</Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default DepotTable;
